import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/img/notice1.png';
const _hoisted_1 = {
  class: "contianer"
};
const _hoisted_2 = {
  key: 0,
  class: "aside"
};
const _hoisted_3 = {
  class: "aside-inner"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "content-title"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  class: "mask-overlay"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", _hoisted_1, [$data.menubar.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menubar, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      onClick: $event => $options.hanldeMenuClick(item),
      key: item.path,
      class: _normalizeClass({
        'menu-item': true,
        'menu-item-active': item.id === $data.current.id,
        'menu-item-first': index === 0,
        'menu-item-last': index === $data.menubar.length - 1
      })
    }, [item.icon ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: item.icon,
      alt: "",
      class: _normalizeClass({
        'menu-item-icon': true,
        'menu-item-icon-active': item.id === $data.current.id
      })
    }, null, 10, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString(item.title), 1)], 10, _hoisted_4);
  }), 128))])])) : _createCommentVNode("", true), $data.menubar.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "content",
    style: _normalizeStyle({
      width: $data.menubar.length > 1 ? '968px' : '100%'
    })
  }, [_createElementVNode("div", _hoisted_6, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "content-title-tag"
  }, null, -1)), _createElementVNode("div", null, _toDisplayString($data.current.title || ""), 1), _createElementVNode("div", {
    class: "notice-box",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleNoticeClick && $options.handleNoticeClick(...args))
  }, _cache[2] || (_cache[2] = [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1), _createTextVNode(" 关于推荐第三届中国医学教育题库命题创新大赛评审专家的通知 ")]))]), _createElementVNode("iframe", {
    onLoad: _cache[1] || (_cache[1] = (...args) => $options.adjustIframeHeight && $options.adjustIframeHeight(...args)),
    ref: "activityIframe",
    class: "iframe",
    src: $data.iframeUrl,
    frameborder: "0"
  }, null, 40, _hoisted_7)], 4)) : _createCommentVNode("", true)], 512), [[_vShow, $data.show]]), $data.showMask ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : _createCommentVNode("", true)]);
}